/*                                                        */
import { DEV } from 'esm-env';
import { render_effect, teardown } from '../../../reactivity/effects.js';
import { listen_to_event_and_reset_event } from './shared.js';
import * as e from '../../../errors.js';
import { is } from '../../../proxy.js';
import { queue_micro_task } from '../../task.js';
import { hydrating } from '../../hydration.js';
import { tick, untrack } from '../../../runtime.js';
import { is_runes } from '../../../context.js';
import { current_batch, previous_batch } from '../../../reactivity/batch.js';

/**
 *
 *
 *
 *
 */
export function bind_value(input, get, set = get) {
	var batches = new WeakSet();

	listen_to_event_and_reset_event(input, 'input', async (is_reset) => {
		if (DEV && input.type === 'checkbox') {
			/*                                   */
			e.bind_invalid_checkbox_value();
		}

		/*              */
		var value = is_reset ? input.defaultValue : input.value;
		value = is_numberlike_input(input) ? to_number(value) : value;
		set(value);

		if (current_batch !== null) {
			batches.add(current_batch);
		}

		/*                                                                      */
		/*                                                                  */
		/*                                             */
		await tick();

		/*                                  */
		if (value !== (value = get())) {
			var start = input.selectionStart;
			var end = input.selectionEnd;
			var length = input.value.length;

			/*                                 */
			input.value = value ?? '';

			/*                */
			if (end !== null) {
				var new_length = input.value.length;
				/*                                                                   */
				if (start === end && end === length && new_length > length) {
					input.selectionStart = new_length;
					input.selectionEnd = new_length;
				} else {
					input.selectionStart = start;
					input.selectionEnd = Math.min(end, new_length);
				}
			}
		}
	});

	if (
		/*                                                   */
		/*                                                 */
		(hydrating && input.defaultValue !== input.value) ||
		/*                                                 */
		/*                                                               */
		(untrack(get) == null && input.value)
	) {
		set(is_numberlike_input(input) ? to_number(input.value) : input.value);

		if (current_batch !== null) {
			batches.add(current_batch);
		}
	}

	render_effect(() => {
		if (DEV && input.type === 'checkbox') {
			/*                                   */
			e.bind_invalid_checkbox_value();
		}

		var value = get();

		if (input === document.activeElement) {
			/*                                                                                       */
			var batch = /*                */ (previous_batch ?? current_batch);

			/*                                                                              */
			/*                                                                  */
			//
			/*                         */
			/*                         */
			if (batches.has(batch)) {
				return;
			}
		}

		if (is_numberlike_input(input) && value === to_number(input.value)) {
			/*                                                                        */
			return;
		}

		if (input.type === 'date' && !value && !input.value) {
			/*                                                                                                                */
			/*                                                                                                                           */
			return;
		}

		/*                                                         */
		/*                         */
		if (value !== input.value) {
			/*                                                  */
			input.value = value ?? '';
		}
	});
}

/*                                  */
const pending = new Set();

/**
 *
 *
 *
 *
 *
 *
 */
export function bind_group(inputs, group_index, input, get, set = get) {
	var is_checkbox = input.getAttribute('type') === 'checkbox';
	var binding_group = inputs;

	/*                                                                        */
	let hydration_mismatch = false;

	if (group_index !== null) {
		for (var index of group_index) {
			/*               */
			binding_group = binding_group[index] ??= [];
		}
	}

	binding_group.push(input);

	listen_to_event_and_reset_event(
		input,
		'change',
		() => {
			/*         */
			var value = input.__value;

			if (is_checkbox) {
				value = get_binding_group_value(binding_group, value, input.checked);
			}

			set(value);
		},
		/*                                 */
		() => set(is_checkbox ? [] : null)
	);

	render_effect(() => {
		var value = get();

		/*                                                                             */
		/*                      */
		if (hydrating && input.defaultChecked !== input.checked) {
			hydration_mismatch = true;
			return;
		}

		if (is_checkbox) {
			value = value || [];
			/*         */
			input.checked = value.includes(input.__value);
		} else {
			/*         */
			input.checked = is(input.__value, value);
		}
	});

	teardown(() => {
		var index = binding_group.indexOf(input);

		if (index !== -1) {
			binding_group.splice(index, 1);
		}
	});

	if (!pending.has(binding_group)) {
		pending.add(binding_group);

		queue_micro_task(() => {
			/*                                                                   */
			binding_group.sort((a, b) => (a.compareDocumentPosition(b) === 4 ? -1 : 1));
			pending.delete(binding_group);
		});
	}

	queue_micro_task(() => {
		if (hydration_mismatch) {
			var value;

			if (is_checkbox) {
				value = get_binding_group_value(binding_group, value, input.checked);
			} else {
				var hydration_input = binding_group.find((input) => input.checked);
				/*         */
				value = hydration_input?.__value;
			}

			set(value);
		}
	});
}

/**
 *
 *
 *
 *
 */
export function bind_checked(input, get, set = get) {
	listen_to_event_and_reset_event(input, 'change', (is_reset) => {
		var value = is_reset ? input.defaultChecked : input.checked;
		set(value);
	});

	if (
		/*                                                   */
		/*                                                */
		(hydrating && input.defaultChecked !== input.checked) ||
		/*                                                       */
		untrack(get) == null
	) {
		set(input.checked);
	}

	render_effect(() => {
		var value = get();
		input.checked = Boolean(value);
	});
}

/**
 *
 *
 *
 *
 *
 */
function get_binding_group_value(group, __value, checked) {
	/*                 */
	var value = new Set();

	for (var i = 0; i < group.length; i += 1) {
		if (group[i].checked) {
			/*         */
			value.add(group[i].__value);
		}
	}

	if (!checked) {
		value.delete(__value);
	}

	return Array.from(value);
}

/**
 *
 */
function is_numberlike_input(input) {
	var type = input.type;
	return type === 'number' || type === 'range';
}

/**
 *
 */
function to_number(value) {
	return value === '' ? null : +value;
}

/**
 *
 *
 *
 */
export function bind_files(input, get, set = get) {
	listen_to_event_and_reset_event(input, 'change', () => {
		set(input.files);
	});

	if (
		/*                                                   */
		/*                                                 */
		hydrating &&
		input.files
	) {
		set(input.files);
	}

	render_effect(() => {
		input.files = get();
	});
}
